import { render, staticRenderFns } from "./TypeaheadList.vue?vue&type=template&id=20f4895e"
import script from "./TypeaheadList.vue?vue&type=script&lang=js"
export * from "./TypeaheadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports